import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Clickable from 'components/Common/Clickable'
import Heading from 'LuxKit/Typography/Heading'
import clsx from 'clsx'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import useToggle from 'hooks/useToggle'
import Expander from 'components/utils/Expander'
import MarkdownRender from 'LuxKit/MarkdownRender'
import Group from 'components/utils/Group'

const Root = styled.div`
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  padding-bottom: 0;
  transition: padding-bottom 0.2s ease;

  &:last-child {
    border-bottom-color: transparent;
  }

  &.is-open {
    padding-bottom: ${rem(16)};

    ${mediaQueryUp.tablet} {
      padding-bottom: ${rem(24)};
    }
  }
`

const SectionHeader = styled(Clickable)`
  width: 100%;
  padding: ${rem(16)} 0;
  ${mediaQueryUp.tablet} {
    padding: ${rem(24)} 0;
  }
`

const ArrowIcon = styled(LineAngleRightIcon)`
  transform: rotate(90deg);
  transition: transform 0.2s ease-out;

  &.rotate-180 {
    transform: rotate(-90deg);
  }
`

interface Props {
  inclusion: App.Tours.V2OfferInclusion
}

function TourV2InclusionSection(props: Props) {
  const { inclusion } = props

  const [open, toggle] = useToggle(false)

  return (
    <Root className={clsx({ 'is-open': open })}>
      <SectionHeader onClick={toggle}>
        <Group direction="horizontal" horizontalAlign="space-between">
          <Heading variant="heading5">{inclusion.title}</Heading>
          <ArrowIcon className={clsx({ 'rotate-180': open })} />
        </Group>
      </SectionHeader>

      <Expander expanded={open}>
        <MarkdownRender content={inclusion.body} />
      </Expander>
    </Root>
  )
}

export default memo(TourV2InclusionSection)
